<template>
  <div
    :class="$style['promotion']
    "
    @click="onClick">
    <img :class="$style['promotion__title']" alt="How to style pregnant X tanjaKvl" src="/images/promotions/pregnant-faves/title.svg?url">
    <Btn
      v-if="(promotionData.link && promotionData.showLink) && shouldShow(promotionData.link)"
      aria-label="Go to promotion"
      icon-only="System/arrow-right-s-line"
      color="cta"
      shape="round" />
  </div>
</template>
<script>
import baseScript from './Shared/script'

export default {
  extends: baseScript
}
</script>
<style lang="scss" module>
@use './Shared/style';

.promotion {
  background-image: url('/images/promotions/pregnant-faves/bg.webp');

  &__title {
    width: 38%;
    position: absolute;
    bottom: calc(var(--spacing ) * 2);
    left: 50%;
    transform: translateX(-50%);
  }
}
</style>
